import Request from '@/http/axios';
import url from '@/http/url.js'

//  示例  {api  访问路径   methods 访问方式 param 传递参数 data 提交数据}
// export const example = (params) => new Request().require({api: '/api/member/Login',param:params,data:datas});

export const getUserInfo = (params) => new Request().require({api: url.userinfo,methods:'GET',param:params}); //获取个人信息

export const getSorts = (params) => new Request().require({api: url.sort,methods:'GET', param: params}); //获取一级分类

export const getSerials = (datas) => new Request().require({api: url.serials, data: datas}); //获取二级分类

export const doLoginMt = (datas) => new Request().require({api: url.login, data: datas}); //登录

export const doRegsiterMt = (datas) => new Request().require({api: url.reg, data: datas}); //注册

export const mtsendCode = (datas) => new Request().require({api: url.verify, data: datas}); //获取验证码

export const mtforgetPass = (datas) => new Request().require({api: url.forgetpass, data: datas}); //修改密码

export const getBannners = (datas) => new Request().require({api: url.banners, data: datas}); //获取轮播

export const getSerialGoods = (datas) => new Request().require({api: url.serialGoods, data: datas}); //获取系列商品

export const getUserAppraises = (params,datas) => new Request().require({api: url.comments,methods: 'POST', param: params, data: datas}); //我的评价

export const addAppraises = (params,datas) => new Request().require({api: url.addAppraises, param: params, data: datas}); //添加评论

export const getGoodsAppraises = (datas) => new Request().require({api: url.getGoodsAppraises, data: datas}); //商品评价

export const updateUserInfo = (params,datas) => new Request().require({api: url.updateUserInfo,param: params, data: datas}); //编辑用户信息

export const getAccountList = (params) => new Request().require({api: url.accountList,methods:'GET',loadingVisble: true,param: params}); //获取账户列表

export const deleteAccount = (params,datas) => new Request().require({api: url.deleteAccount,param: params, data: datas}); //删除账户

export const addAliPay = (params,datas) => new Request().require({api: url.addAliPay,param: params, data: datas}); //添加支付寶賬戶

export const addCard = (params,datas) => new Request().require({api: url.addCard,param: params, data: datas}); //添加銀行卡賬戶

export const updateUserPass = (params,datas) => new Request().require({api: url.updateUserPass,param: params, data: datas}); //修改登錄密碼

export const updatePayPass = (params,datas) => new Request().require({api: url.updatePayPass,param: params, data: datas}); //修改支付密碼

export const setupPayPassword = (params,datas) => new Request().require({api: url.setupPayPassword,param: params, data: datas}); //设置支付（兑换）密码

export const getBonus = (params) => new Request().require({api: url.getBonus,methods:'GET',param: params}); //我的积分信息

export const groups = (params) => new Request().require({api: url.groups,param: params}); //我的团队信息

export const getExpInfo = (params,datas) => new Request().require({api: url.expInfo,param: params, data: datas}); //查看物流

export const getAdsList = (params) => new Request().require({api: url.addressList,methods:'GET',param: params}); //收货地址列表

export const addAddress = (params,datas) => new Request().require({api: url.addAddress, data:datas, param: params}); //添加收货地址

export const updateAddress = (params,datas) => new Request().require({api: url.updateAddress, data:datas, param: params}); //编辑收货地址

export const deleteAddress = (params,datas) => new Request().require({api: url.deleteAddress, data:datas, param: params}); //删除收货地址

export const getOrderList = (params,datas) => new Request().require({api: url.orderList, data:datas, param: params}); //订单列表

export const getGoodsByGoodsNum = (datas) => new Request().require({api: url.getGoodsByGoodsNum, data:datas}); //商品详情

export const getSku = (datas) => new Request().require({api: url.getSku, data:datas}); //获取商品所有的类型

export const getOrderByOrderNum = (params, datas) => new Request().require({api: url.getOrderByOrderNum,param: params, data:datas}); //商品详情

export const getOrderNumByOrderId = (params, datas) => new Request().require({api: url.getOrderNumByOrderId,param: params, data:datas}); //商品详情

export const cancelOrder = (params, datas) => new Request().require({api: url.cancelOrder,param: params, data:datas}); //商品详情

export const getRecGoods = (params, datas) => new Request().require({api: url.recGoodsList,param: params, data:datas}); //推荐商品

export const getHotGoods = (params, datas) => new Request().require({api: url.hotGoodsList,param: params, data:datas}); //热门商品

export const getRecGoodsNoUser = (datas) => new Request().require({api: url.recGoodsListNoUser, data:datas}); //未登录推荐商品

export const getAllGoods = (params, datas) => new Request().require({api: url.allGoodsList, param: params, data:datas}); //所有商品

export const getAllGoodsNoUser = (datas) => new Request().require({api: url.allGoodsListNoUser, data:datas}); //未登录所有商品

export const getBonusGoods = (params, datas) => new Request().require({api: url.bonusGoodsList,param: params, data:datas}); //积分商品

export const transBonus = (params, datas) => new Request().require({api: url.transBonus,param: params, data:datas}); //积分转赠

export const getMobileUser = (params, datas) => new Request().require({api: url.mobileUser,param: params, data:datas}); //查询用户

export const getScoreRecord = (params, datas) => new Request().require({api: url.scoreRecord,param: params, data:datas}); //兑换记录

export const convertBounds = (params, datas) => new Request().require({api: url.convertBounds,param: params, data:datas}); //积分转赠

export const getScoreDetail = (params, datas) => new Request().require({api: url.scoreDetail,param: params, data:datas}); //积分详情

export const getOrderScoreListByType = (params, datas) => new Request().require({api: url.typescorelist,param: params, data:datas}); //可兑积分、未兑积分

export const getShareInfo = (params,datas) => new Request().require({api: url.share, param: params, data:datas}); //推广详情

export const getShareList = (params) => new Request().require({api: url.shareList,methods:'GET', param: params}); //推广详情

export const addCart = (params, datas) => new Request().require({api: url.addCart,param: params, data:datas}); //加入购物车

export const getCartList = (params, datas) => new Request().require({api: url.shopCart,param: params, data:datas}); //获取购物车列表

export const getCartInfo = (params, datas) => new Request().require({api: url.getCartInfo,param: params, data:datas}); //获取购物车信息

export const getGroupingInfo = (params, datas) => new Request().require({api: url.getGroupingInfo,param: params, data:datas}); //获取

export const getGroupingInfoOne = (params, datas) => new Request().require({api: url.getGroupingInfoOne,param: params, data:datas}); //获取

// export const getGroupingJoinInfo = (params, datas, groupId) => new Request().require({api: url.getGroupingJoinInfo + groupId,param: params, data:datas}); //获取
export const getGroupingJoinInfo = (params, groupId) => new Request().require({api: url.getGroupingJoinInfo + groupId,param: params}); //获取

export const deleteCart = (params, datas) => new Request().require({api: url.deleteCart,param: params, data:datas}); //删除购物车

export const getFriends = (params) => new Request().require({api: url.friends,methods: 'GET', param: params}); //好友列表

export const refundApply = (params, datas) => new Request().require({api: url.refundApply, param: params, data:datas}); //申请退货（退款）

export const getRefundList = (params, datas) => new Request().require({api: url.refundList,  param: params, data:datas}); // 退货退款列表

export const getNotificationList = (datas) => new Request().require({api: url.notification,  data:datas}); // 系统通知

export const getSearchList = (params, datas) => new Request().require({api: url.searchList,  param: params, data:datas}); // 搜索

export const orderReceipt = (params, datas) => new Request().require({api: url.orderReceipt, param: params, data:datas}); // 确认收货

export const getBankList = () => new Request().require({api: url.bankList, methods: 'GET'}); // 代付银行列表

export const getNewsList = (datas) => new Request().require({api: url.newsList, data:datas}); // 新闻列表

export const getNewsDetailById = (id) => new Request().require({methods: 'GET', api: url.newsDetailById + id}); // 新闻详情

export const orderSave = (params, datas, text) => new Request().require({api: url.orderSave, param: params, data:datas, loadingVisble: true , loadingText: text}); // 提交订单

export const getDefaultAddress = (params) => new Request().require({api: url.getDefaultAddress, methods: 'GET', param: params}); // 默认地址

export const pointPay = (datas) => new Request().require({api: url.pointPay,  data:datas}); // 积分支付

export const wxPay = (datas) => new Request().require({api: url.wxPay,  data:datas}); // 微信支付

export const aliPay = (datas) => new Request().require({api: url.aliPay, data:datas}); // 支付宝支付

export const payResult = (params, datas) => new Request().require({api: url.getDefaultAddress, param: params, data:datas}); // 支付结果

export const getUserInfoById = (datas) => new Request().require({api: url.getUserInfoById, data:datas}); // 获取用户信息

export const getFileByType = (datas) => new Request().require({api: url.getFileByType, data:datas}); // 获取文件

export const getPaySuccInfo = (params, datas) => new Request().require({api: url.orderPaySucc, param: params, data:datas}); // 支付成功

export const getPaySuccInfoNew = (params, datas) => new Request().require({api: url.orderPaySuccNew, param: params, data:datas}); // 支付成功

export const getReasonList = () => new Request().require({api: url.returnReason}); // 获取退货原因列表

export const setDefaultAddress = (params,datas) => new Request().require({api: url.defaultAddress, param: params, data:datas}); // 设置默认地址

export const wxJsPay = (params, datas) => new Request().require({api: url.wxJsPay, param: params, data:datas}); // 微信公众号支付

export const wxJsPayNew = (params, datas) => new Request().require({api: url.wxJsPayNew, param: params, data:datas}); // 微信公众号支付

export const getAddressAndGoods = (params, datas) => new Request().require({api: url.addressAndGoods, param: params, data:datas});
// 订单确认页面
export const getCartGroupId = (params, datas) => new Request().require({api: url.getCartGroupId, param: params, data:datas}); // 订单确认页面

export const updateGroupInfo = (params, orderId) => new Request().require({api: url.updateGroupInfo + orderId, param: params}); // 订单确认页面

export const getCartGroupInfo = (params, datas) => new Request().require({api: url.getCartGroupInfo, param: params, data:datas}); // 订单确认页面

export const getWxConfig = (datas) => new Request().require({api: url.wxConfig, data:datas}); // 获取微信参数配置

export const saveFeedback = (params, datas) => new Request().require({api: url.feedback, param: params, data:datas}); // 问题反馈

export const getNewsDetail = (datas) => new Request().require({api: url.newsDetail, data:datas}); // 新闻详情

export const getAllSerials = (params) => new Request().require({api: url.getAllSerials, param: params, methods: 'GET'}); // 获取所有分类信息

export const shareGoods = (params, id) => new Request().require({api: url.shareGoods + id, param: params, methods: 'GET'}); // 分享商品

export const getPostageInfo = (params) => new Request().require({api: url.getPostageInfo, param: params, methods: 'GET'}); // 获取邮费信息







// WEBPACK FOOTER //
// ./src/http/getData.js